import {
  ChangeDetectionStrategy,
  Component,
  ViewContainerRef
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { filter, take } from 'rxjs';
import { RetailProductService } from 'src/app/shared/services/retail-product.service';
import { AddTemplateDialogComponent } from '../add-template-dialog/add-template-dialog.component';
import { TemplateStoreService } from './template-index.store.service';
import { TemplateTableComponent } from './template-table/template-table.component';
import { MatButton } from '@angular/material/button';
import { WorkshopJobTemplateService } from 'src/app/shared/services/workshop-job-template.service';

@Component({
  selector: 'app-template-index',
  templateUrl: './template-index.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    TemplateStoreService,
    RetailProductService,
    WorkshopJobTemplateService
  ],
  standalone: true,
  imports: [MatButton, TemplateTableComponent]
})
export class TemplateIndexComponent {
  templates$ = this.store.templates$;

  filter = new FormControl<string>('');

  constructor(
    private store: TemplateStoreService,
    private dialog: MatDialog,
    private vcr: ViewContainerRef
  ) {
    this.store.getTemplates();
  }

  addTemplate() {
    this.dialog
      .open(AddTemplateDialogComponent, {
        width: '800px',
        viewContainerRef: this.vcr
      })
      .afterClosed()
      .pipe(
        take(1),
        filter((result) => Boolean(result))
      )
      .subscribe(({ updateList }) => {
        if (updateList) {
          this.store.getTemplates();
        }
      });
  }
}
